import React, {Component} from 'react';
import {Modal, ModalHeader} from 'reactstrap';
import {AddAccountForm} from "./AddAccountForm";
import {Button} from 'reactstrap';
import { withTranslation } from 'react-i18next';

class AddAccountModalClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: this.props.showModalWhenCreated,
        };

        this.toggle = this.toggle.bind(this);
        this.afterSuccessfulSubmit = this.afterSuccessfulSubmit.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    afterSuccessfulSubmit(dataByNewId) {
        this.toggle();
        this.props.afterSuccessfulSubmit(dataByNewId);
    }

    render() {
        const { t } = this.props;
        return (
            <div className="add-account-modal">
                <Button key="button" className="btn -alt" onClick={this.toggle}>{t('add_account_modal.add_accounts_button')}</Button>

                <Modal key="modal" isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} backdrop={"static"}>
                    <ModalHeader toggle={this.toggle}>{this.renderAddAccountModalTitle()}</ModalHeader>
                    {this.renderAddAccountForm()}
                </Modal>
            </div>
        )
    }

    renderAddAccountForm() {
        return <AddAccountForm businessUnitId={this.props.businessUnitId}
                               allocatedBudget={this.props.allocatedBudget}
                               afterSuccessfulSubmit={this.afterSuccessfulSubmit}
        />;
    }

    renderAddAccountModalTitle() {
        const { t } = this.props;
        return t('add_account_modal.title')
    }
}

export const AddAccountModal = withTranslation()(AddAccountModalClass);
export default AddAccountModal;
